import { Component, Input, OnInit } from '@angular/core';
import { GetPersonModel, PersonModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-player-info',
    templateUrl: './player-info.component.html',
    styleUrls: ['./player-info.component.scss'],
    standalone: false
})
export class PlayerInfoComponent implements OnInit {
    @Input() player: GetPersonModel | PersonModel;
    constructor() { }

    ngOnInit(): void { }

    get isExistingPlayer(): boolean {
        return this.player && this.player.personId !== null;
    }

    get isAddedPlayer(): boolean {
        return this.player && this.player.personId === null;
    }
    get userName(): string {
        return `${this.player.firstName} ${this.player.lastName}`;
    }
}
